export default function postRoleReducer
  (state = { error:'', success:'', processing:false}, action)
{
  switch (action.type) {
    case 'POST_ROLE_SUCCESS':
      return {...state, ...{success: action.success}};

    case 'POST_ROLE_ERROR':
      return {...state, ...{error: action.error}};

    case 'POST_ROLE_PROCESSING':
      return {...state, ...{processing: action.processing}};

    default: return state;
  }
}